import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ELegalForm } from '../../../repositories/dailyrent/entities/request/PublicV1ReceiptDetailsSaveRequestSchema';

export interface IFormDataState {
  email: string;
  firstName: string;
  inn: string;
  lastName: string;
  patronymic: string;
  phone: string;
  legalForm?: ELegalForm;
}

export const initialState: IFormDataState = {
  email: '',
  firstName: '',
  inn: '',
  lastName: '',
  patronymic: '',
  phone: '',
  legalForm: undefined,
};

const formDataSlice = createSlice({
  name: 'formData',
  initialState,
  reducers: {
    setFormData(_, action: PayloadAction<IFormDataState>) {
      return {
        email: action.payload.email,
        firstName: action.payload.firstName,
        inn: action.payload.inn,
        lastName: action.payload.lastName,
        patronymic: action.payload.patronymic,
        phone: action.payload.phone,
        legalForm: action.payload.legalForm,
      };
    },
  },
});

export const {
  reducer: formDataReducer,
  actions: { setFormData },
} = formDataSlice;
